import styled from 'styled-components'

export const suggestionItemHeightInPx = 40

export const SuggestionItem = styled.li`
  display: flex;
  padding: 0 1px 0 1px;
  align-items: center;
  list-style: none;
  text-decoration: none;
`

export const SuggestionItemButton = styled.button<{
  isSelected: boolean
}>`
  display: flex;
  align-items: baseline;
  text-align: left;
  width: 100%;
  max-height: ${suggestionItemHeightInPx}px;
  border: none;
  border-bottom: 1px solid ${({ theme }) => theme.colors.coolGray.cool450};
  background: transparent;
  padding: 10px 0;
  transition: 0.3s;
  &:hover,
  &:focus {
    cursor: pointer;
    background: ${({ theme }) => theme.colors.coolGray.cool250};
  }
  &:last-of-type {
    border-bottom: none;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }
  &:first-of-type {
    border-top: 1px solid ${({ theme }) => theme.colors.coolGray.cool450};
  }
  @media (min-width: 640px) {
    background: ${({ isSelected, theme }) =>
      isSelected ? theme.colors.coolGray.cool250 : 'transparent'};
  }
`

export const SuggestionMainText = styled.p`
  margin: 0;
`

export const SuggestionSecondaryText = styled.p`
  margin: 0 0 0 5px;
  font-size: 0.7rem;
`

export const LocationIcon = styled.img`
  width: 15px;
  margin: 0 10px;
`
